module.exports = __webpack_public_path__ + "static/team2-19870257c1b4b0cee9eef7a318627d25.jpg";